<template>
  <mt-popup v-model="moduleState.chapterset" :modal=false popup-transition="popup-fade" class="page-module">
    <app-header v-bind="headerConfig"></app-header>
    <ul class="story-type clearfix" v-if="!isChangeChapter">
      <li v-for="(list) in storyTypes" :class="{'act': addSelectClass(list.type)}" class="list"
          @click="typeSelect(list.type)">
        <span v-html="list.note" class="tab"></span>
      </li>
    </ul>

    <div v-if="!isChangeChapter" class="chapter-setting clearfix">
      <div class="type-cover fl">
        <img :src="parrent.types[storyType].pic" alt="parrent.types[storyType].name">
      </div>
      <ul class="items">
        <li class="set-name">
          <input type="text" placeholder="输入章节名称" v-model.trim="chapter.name" maxlength="20">
        </li>
        <li class="set-static" @click="openLibrary(imageLibrary, 67)">
          {{chapterConfig.bg === null? '背景图': chapterConfig.bg.file_name}}
        </li>
        <li class="set-static" @click="openLibrary(musicLibrary, 68)">
          {{chapterConfig.bgm ===null? '背景音乐': chapterConfig.bgm.name}}
        </li>
      </ul>
    </div>

    <div class="set-role">
      <p class="slogan">请选择当前章节的登场角色</p>
      <div class="stage-roles clearfix">
        <ul>
          <li class="role-list">
            <img src="../../static/image/aside.jpg" alt="旁白" class="role-pic">
            <div class="role-name aside elli">旁白</div>
          </li>
          <li class="role-list" :class="{'leading-sign': stageRoles.main.length > 0}" @click="addStageRole('main', 69)">
            <template v-if="stageRoles.main.length <= 0">
              <img src="../../static/image/add_role.png" alt="主角" class="role-pic">
              <p class="role-name leading elli">主角</p>
            </template>
            <template v-else>
              <img :src="commentMethods.getRoleCover(stageRoles.main[0])" class="role-pic">
              <p class="role-name leading elli">{{stageRoles.main[0].name}}</p>
            </template>
          </li>
          <li v-for="role in stageRoles.costar" @click="addStageRole('costar', 70)" class="role-list costar-sign">
            <img :src="commentMethods.getRoleCover(role)" class="role-pic">
            <p class="role-name costar elli">{{role.name}}</p>
          </li>
          <li class="role-list" @click="addStageRole('costar', 70)">
            <img src="../../static/image/add_role.png" alt="配角" class="role-pic">
            <p class="role-name costar elli">配角</p>
          </li>
        </ul>
      </div>
      <div class="btns clearfix">
        <a href="javascript:;" class="btn" @click="close">取消</a>
        <a href="javascript:;" class="btn save" @click="saveChapter">确定</a>
      </div>
    </div>
    <malib-music v-if="moduleState.musicLibrary"></malib-music>
    <malib-bg v-if="moduleState.imageLibrary"></malib-bg>
  </mt-popup>
</template>

<script>
  import Vue from 'vue';
  import {mapState} from 'vuex';
  import {Toast} from 'mint-ui';
  import store from '../store/store';
  import {GameData} from '../store/GameData';
  import AppHeader from '../components/header';
  import roleList from '../components/role_list';
  import MalibBG from '../components/malib_bg';
  import MalibMusic from '../components/malib_music';
  import {ComponentName, Methods} from '../const/common';

  export default {
    name: 'chapters_set',
    components: {
      'app-header': AppHeader,
      'malib-bg': MalibBG,
      'malib-music': MalibMusic
    },
    computed: {
      watchChapterName() {
        return this.chapter.name;
      },
      ...mapState(['moduleState', 'vagueChapterName', 'chapterList', 'chapterConfig', 'chapterSet', 'stageRoles', 'parrent', 'storyRoles', 'isAddChapter', 'addChapterType', 'isChangeChapter'])
    },
    data() {
      return {
        headerConfig: {
          title: '章节设置',
          isStoryMenu: false,
          backNote: store.state.nextPageHeaderConf.chapterSet.backNote,
          backPage: store.state.nextPageHeaderConf.chapterSet.backPage,
          closeModule: ComponentName.CHAPTER_SET
        },
        storyTypes: [
          {type: 0, note: '对话模式'},
          {type: 1, note: '视觉模式'},
          {type: 2, note: '情景模式'}
        ],
        imageLibrary: ComponentName.IMAGE_LIBRARY,
        musicLibrary: ComponentName.MUSIC_LIBRARY,
        roleListType: {
          type: 'editStory',
          status: ''
        },
        chapter: {
          name: store.state.vagueChapterName
        },
        storyType: store.state.parrent.createPattern,
        storyTypeChange: false,
        commentMethods: Methods
      }
    },
    store,
    methods: {
      close() {
        store.state.addChapterType = null;
        store.commit('editStorySetout');
        Methods.clearStageRoleSign();
        Methods.cutComponent('all', false);
        Methods.cutComponent([store.state.nextPageHeaderConf.chapterSet.backPage], true);
        Methods.checkChapterHash(71);
      },
      typeSelect(type) {
        this.storyType = type;
        this.storyTypeChange = true;
        store.state.addChapterType = type;
        Methods.checkChapterHash(66);
      },
      addSelectClass(type) {
        let res = false;

        if (this.addChapterType !== null) {
          if (this.addChapterType === type) {
            res = true;
          }
        } else if (this.storyType === type) {
          res = true
        }
        return res;
      },
      openLibrary(type, hash) {
        Methods.openMaLib(type, 'set');
        Methods.checkChapterHash(33, hash);
      },
      addStageRole(type, hash) {
        Methods.setHeaderConf('roleList', '章节设置', ComponentName.CHAPTER_SET);
        this.stageRoles.status = type;
        Methods.cutComponent([ComponentName.ROLE_LIST], true);
        Methods.checkChapterHash(hash);
      },
      saveChapter() {
        try{
          let _roles = [{id: 0, name: '旁白', characterType: Methods.getRoleStatus('sys')}],
            role = {}, _createPattern = '';

          if (this.isChangeChapter) {
            let roles = this.stageRoles.main.concat(this.stageRoles.costar), status;

            roles.forEach(function (role) {
              if (role.status === 'main') {
                try{
                  Middle.MiddleCommand.addMainChapterCharacter(role.id)
                } catch(e){
                  ErrorUpdate.getUserInfoUpErro(appVersion, "添加章节错误-1:" + e.stack, "release");
                }
              } else {
                status = Methods.getRoleStatus('costar');
                try{
                  Middle.MiddleData.AddChapterChar(role.id, status);
                } catch(e){
                  ErrorUpdate.getUserInfoUpErro(appVersion, "添加章节错误-2:" + e.stack, "release");
                }
              }
            });
            Methods.clearUseRole();
            store.state.setRoleSiteDom = false;
            Methods.checkChapterHash(115);
          } else {
            if (this.vagueChapterName === '') {
              return Toast({
                message: '请填写章节名。'
              });
            } else if (this.vagueChapterName.length < 2) {
              return Toast({
                message: '章节名太短。'
              });
            }

            if (this.stageRoles.main.length > 0) {
              role = {
                id: this.stageRoles.main[0].id,
                name: this.stageRoles.main[0].name,
                isMain: true,
                characterType: this.stageRoles.main[0].characterType
              };
              _roles.push(role);
            } else {
              return Toast({
                message: '未设置主角，不能开始编剧。'
              });
            }
            for (let i in this.stageRoles.costar) {
              role = {
                id: this.stageRoles.costar[i].id,
                name: this.stageRoles.costar[i].name,
                isMain: false,
                characterType: this.stageRoles.costar[i].characterType
              };
              _roles.push(role)
            }
            if (this.addChapterType !== null) {
              _createPattern = this.addChapterType;
            } else {
              if (this.storyTypeChange) {
                _createPattern = this.storyType;
              } else {
                _createPattern = this.parrent.createPattern;
              }
            }
            this.parrent.createPattern = _createPattern;
            Methods.setHeaderConf('editStory', '返回', ComponentName.STORYS_LIST);
            try{
              var newChapterId = GameData.AddChapter(this.vagueChapterName, this.chapterConfig, _createPattern, _roles);
            }catch(e) {
              ErrorUpdate.getUserInfoUpErro(appVersion, "添加章节错误-5:" + e.stack, "release");
            }
            if (newChapterId === -1) {
              return;
            }
            if (store.state.isAddjump) {
              try{
                GameData.AddEvent("event_jump", [newChapterId]);
              }catch(e) {
                ErrorUpdate.getUserInfoUpErro(appVersion, "添加章节错误-6:" + e.stack, "release");
              }
            }
            store.state.useRole = {cover: null, name: "", mood: 'normal'};
            store.state.setRoleSiteDom = false;
            try{
              GameData.enterChapter(Middle.ProjectData.chapter.values().length - 1);
            }catch(e) {
              ErrorUpdate.getUserInfoUpErro(appVersion, "添加章节错误-3:" + e.stack, "release");
            }
            Methods.checkChapterHash(72);
          }
          store.state.editMsgText = '';
          try{
            Middle.MiddleData.SetStatus(2);
          }catch(e) {
            ErrorUpdate.getUserInfoUpErro(appVersion, "添加章节错误-4:" + e.stack, "release");
          }
          this.close();
          Methods.cutComponent([ComponentName.EDIT_STORY_ROLE], false);
          Methods.cutComponent([ComponentName.EDIT_STORY], true);
          Methods.clearStageRoleSign();
        } catch(e) {
          Toast({
            message: '新建章节异常，请退出后重新进入'
          });
          console.log("出错了:" + e.stack);
          ErrorUpdate.getUserInfoUpErro(appVersion, "添加章节错误:" + e.stack,"release");
          CanvasCommand.saSend(11, {
            sting_value_2: Methods.getGuid(),
            number_value_1: ErrorCode.NEW_CHAPTER_ERROR_CODE_VUE
          })
        }
      }
    },
    mounted: function () {
      if (store.state.isChangeChapter) {
        let nowChapter = [], stageRole = null, stage = '', _store = store.state;

        _store.vagueChapterName = Methods.getChapterVal('nowChapter').name;
        if (!(_store.stageRoles.main.length > 0 || _store.stageRoles.costar.length > 0)) {
          _store.stageRoles.main = [];
          _store.stageRoles.costar = [];
          nowChapter = Middle.MiddleData.getCurrentChapterChatList();

          nowChapter.forEach(function (role) {
            // console.log(role)
            stageRole = Methods.getCharacter(role.id);
            stageRole.characterType = role.characterType;
            Vue.set(stageRole, 'stage', true);

            if (role.characterType === Methods.getRoleStatus('main')) {
              Vue.set(stageRole, 'status', 'main');
              stage = 'main';
              _store.stageRoles.main.push(stageRole)
            } else {
              if (role.characterType !== Methods.getRoleStatus('sys')) {
                stage = 'costar';
                _store.stageRoles.costar.push(stageRole);
              }
            }
            Vue.set(stageRole, 'status', stage);
          });
        }
      }
    },
    watch: {
      watchChapterName() {
        store.state.vagueChapterName = this.chapter.name.replace(store.state.emoReg, '');
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/chapters_set.css";
</style>



// WEBPACK FOOTER //
// src/components/chapters_set.vue